export const ROUTE_MAP: Record<string, string> = {
  "EntradaApp": "/entrada-app",
  "LoginColl": "/login-coll",
  "ServiciosDashboard": "/servicios-dashboard",
  "Empresas": "/empresas",
  "Usuarios": "/usuarios",
} as const;
